"use strict";

exports.__esModule = true;
exports.ElementRenderer = ElementRenderer;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Renders a React component tree based on a configuration object and a dictionary
 * of components.
 */
function ElementRenderer(_ref) {
  var components = _ref.components,
    _ref$defaultComponent = _ref.defaultComponent,
    defaultComponent = _ref$defaultComponent === void 0 ? DefaultElement : _ref$defaultComponent,
    config = _ref.config,
    _ref$modifyProps = _ref.modifyProps,
    modifyProps = _ref$modifyProps === void 0 ? function (input) {
      return input;
    } : _ref$modifyProps,
    updateLayout = _ref.updateLayout,
    Wrapper = _ref.Wrapper;
  var _renderItem = function renderItem(element, path) {
    if (element == null) {
      return null;
    }
    if (Array.isArray(element)) {
      var parts = [];
      for (var i = 0; i < element.length; i++) {
        parts.push(_renderItem(element[i], path.concat(i)));
      }
      return parts;
    }
    var render = function render(element, key) {
      return _renderItem(element, key === undefined ? path.concat("children") : path.concat("children", key));
    };
    var key = path.join("/");
    var Component = components[element.type] || defaultComponent;
    var body = /*#__PURE__*/_react["default"].createElement(Component, modifyProps(Object.assign({
      type: element.type
    }, element.props, {
      key: key,
      path: path,
      render: render,
      children: element.children,
      updateLayout: updateLayout
    })));
    if (Wrapper) {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        key: key,
        path: path,
        element: element
      }, body);
    }
    return body;
  };
  return _renderItem(config, []);
}
function DefaultElement(_ref2) {
  var render = _ref2.render,
    children = _ref2.children;
  return render(children);
}